export default "__VITE_ASSET__Dt2jTWSH__"